import React from "react";
import { Sparkles } from "lucide-react";
import { EmptyLegMarket } from "@/components/EmptyLegMarket";

export default function Demandes() {
  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <Sparkles className="h-6 w-6 text-primary" /> Demande de transport (IA)
        </h1>
        <p className="text-muted-foreground text-sm">Émettez une demande : l'IA propose les trajets à vide compatibles publiés par vos transporteurs.</p>
      </div>
      <EmptyLegMarket canPublish={false} />
    </div>
  );
}
